import { render, staticRenderFns } from "./allStatic.vue?vue&type=template&id=b9fec730"
import script from "./allStatic.vue?vue&type=script&lang=js"
export * from "./allStatic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports